import { Typography } from '@material-ui/core'
import useStyles from '../styles'
import InfoWrapper from './InfoWrapper'

const CoownerInfo = ({ record }) => {
  const { coowner_info } = record
  if (!coowner_info) return null
  const classes = useStyles()
  if (coowner_info) {
    return (
      <div className={classes.root}>
        <div className={classes.beginBar}></div>
        <Typography classeName={classes.title} gutterBottom>
          Copropriétaire demandeur
        </Typography>
        <InfoWrapper title="Nom" value={coowner_info.name} />
        <InfoWrapper title="Prenom" value={coowner_info.lastname} />
        <InfoWrapper title="Mail" value={coowner_info.mail} />
      </div>
    )
  }
  return null
}

export default CoownerInfo
